import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'ngxUsername',
    standalone: true
})
export class UsernamePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) {}

  transform(user: any): string {
    let result = '';
    if(typeof user === 'string') {
      return user.trim();
    }
    if (user) {
      if (user.first_name && user.last_name) {
        result += `${user.first_name} ${user.last_name}`;
      } else if (user.first_name) {
        result += `${user.first_name}`;
      } else if (user.last_name) {
        result += `${user.last_name}`;
      }
      else {
        result += user.email;
      }

      if (user.corporate_name) {
        result += ` (${user.corporate_name})`;
      }
    }

    if (result === '') {
      result = this.translate.instant(
        'pages.common.charts.lifecycle-chart.unknown-user',
      );
    }

    return result;
  }
 }
